/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gpRejectSubreason: NonNullable<unknown> }} Coinvestments_Tracking_Reject_Gptooltipsubreason3Inputs */

const en_coinvestments_tracking_reject_gptooltipsubreason3 = /** @type {(inputs: Coinvestments_Tracking_Reject_Gptooltipsubreason3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sub-reason: ${i?.gpRejectSubreason}`)
};

/**
* | output |
* | --- |
* | "Sub-reason: {gpRejectSubreason}" |
*
* @param {Coinvestments_Tracking_Reject_Gptooltipsubreason3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_reject_gptooltipsubreason3 = /** @type {((inputs: Coinvestments_Tracking_Reject_Gptooltipsubreason3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Reject_Gptooltipsubreason3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_reject_gptooltipsubreason3(inputs)
});
export { coinvestments_tracking_reject_gptooltipsubreason3 as "coInvestments_tracking_reject_gpTooltipSubreason" }